module.exports = __webpack_public_path__ + "img/white_pawn.6bc087c3.png";